import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `EntradaAlmacen/editarEntradaAlmacen`, method: 'POST', body: values, token: token})
}